import Column from './Column';

export { Props } from './Column';
export default Column;
